module.exports = __webpack_public_path__ + "09ad3649cefc511e2e20b98991116a59.otf";


//////////////////
// WEBPACK FOOTER
// C:/Users/Pili/AppData/Roaming/npm/~/pink/css/fonts/HelveticaNeue/HelveticaNeueLTStd-BdIt.otf
// module id = 343
// module chunks = 0